<template>
	<div class="notification" :class="'is-' + level">
		<button
			v-if="closable"
			aria-hidden="true"
			class="delete"
			data-dismiss="alert"
			title="Close"
			type="button"
			v-on:click="close()"
		></button>
		<span v-html="message"></span>
	</div>
</template>

<script>
	export default {
		props: {
			level: {
				type: String,
				required: true
			},
			message: {
				type: String,
				required: true
			},
			closable: {
				type: Boolean,
				default: true,
			},
		},
		methods: {
			close: function()
			{
				if( this.closable )
				{
					this.$emit('close');
				}
			}
		},
	}
</script>
